<div class="conatiner-fluid">
  <div class="row" style="height: 100vh">
    <div
      class="col-md-6 d-none d-md-block"
      style="
        background-image: url('../../../assets/images/newLogin_IMAGE.jpg');
        background-size: cover;
        background-position: center;
      "
    ></div>
    <div class="col-md-6 d-flex align-items-center" *ngIf="screen_1 == true">
      <div class="w-100 p-4" *ngIf="screen_1 == true">
        <div class="back_Div mb-3" routerLink="/auth/login">
          <img src="../../../assets/images/IconleftTurn.svg" /> Back
        </div>
        <img
          src="../../../assets/images/logo_without_Text2.svg"
          class="logo_Img"
        />
        <p class="login_Text mt-4">Enter Your Registered Email</p>
        <form [formGroup]="loginForm">
          <div class="form-group mt-5">
            <label for="email">Email Address</label>
            <input
              type="email"
              class="form-control form_Input mt-2"
              id="email"
              placeholder=""
              formControlName="email"
            />
            <div
              *ngIf="
                loginForm.controls['email']?.invalid &&
                (loginForm.controls['email']?.dirty ||
                  loginForm.controls['email']?.touched)
              "
              class="errorinput text-left"
            >
              <div *ngIf="loginForm.controls['email']?.errors.required">
                *Email is required.
              </div>
              <div *ngIf="loginForm.controls['email']?.errors.pattern">
                *Invalid email .
              </div>
            </div>
          </div>

          <div class="button_div mt-5">
            <button
              [disabled]="!loginForm.valid"
              type="submit"
              class="btn btn-primary btn-Login"
              (click)="createOtp()"
            >
              Next <img src="../../../assets/images/IconRightturn.svg" />
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-6 p-4" *ngIf="isOtpScreen == true">
      <div class="back_Div mb-3" (click)="backTo()">
        <img src="../../../assets/images/IconleftTurn.svg" /> Back
      </div>
      <img
        src="../../../assets/images/logo_without_Text2.svg"
        class="logo_Img"
      />
      <!-- <p class="login_Text mt-4">Login</p> -->
      <div class="signIn_Text mt-5">
        <!-- <div class="form_outer col-8"> -->
        <div
          [style.padding-top]="'20px'"
          [style.margin-bottom]="'20px'"
          class=""
        >
          <!-- <img src="../../../assets/images/otp_image.svg" /> -->
          <!-- <h4 class="vertical-align-center otp_verify ms-2">
              OTP Verification
            </h4> -->
          <span class="verify_emailTxt mb-2">Verify Email</span>
          <p class="enter_ mt-3">
            Enter OTP Sent to your email
            <strong> {{ userEmail }}</strong>
            <!-- <span [style.font-weight]="'500'" [style.font-size]="'11px'">{{
                signupForm.controls["email"].value
              }}</span> -->
          </p>
        </div>
        <div class="otpDiv mt-3 mb-2">
          <ng-otp-input
            #ngOtpInput
            (onInputChange)="onOtpChange($event)"
            *ngIf="showOtpComponent"
            [config]="{
              length: 4,
              allowNumbersOnly: true,
              cssClass: 'custom-otp-input'
            }"
          ></ng-otp-input>
        </div>

        <!-- <div class="loginDiv mt-5">
            <button
              [disabled]="otpToken == null || otpToken.length < 4"
              class="btn mt-4 text-center submit_btn login_btn"
              (click)="verifyOtp()"
            >
              Next
            </button>
          </div> -->
      </div>
      <div class="signup_text pb-5 mt-1">
        <span
          >Didn't Recieve an OTP?
          <span
            [style.color]="'#4B3E90'"
            style="cursor: pointer; color: #4b3e90"
            (click)="createOtp()"
          >
            Resend</span
          ></span
        >
      </div>
      <div class="button_div mt-5">
        <button
          [disabled]="otpToken == null || otpToken.length < 4"
          type="submit"
          class="btn btn-primary btn-Login"
          (click)="verifyOtp()"
        >
          Continue <img src="../../../assets/images/IconRightturn.svg" />
        </button>
      </div>
    </div>

    <div class="col-md-6 p-4" *ngIf="isOtpScreen == false && screen_1 == false">
      <div class="back_Div mb-3" (click)="backTo()">
        <img src="../../../assets/images/IconleftTurn.svg" /> Back
      </div>
      <img
        src="../../../assets/images/logo_without_Text2.svg"
        class="logo_Img"
      />
      <p class="login_Text mt-4">Change Password</p>
      <form [formGroup]="signupForm">
        <div class="form-group mt-4">
          <label for="email">New Password</label>

          <div class="password-container">
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              type="email"
              class="form-control form_Input mt-2"
              id="newPassword"
              placeholder="Enter new password"
              formControlName="newPassword"
            />
            <img
              src="{{
                passwordVisible
                  ? 'assets/images/eye.svg'
                  : 'assets/images/eye-slash.svg'
              }}"
              alt="Toggle password visibility"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
            />
          </div>
          <div
            *ngIf="
              signupForm.controls['newPassword'].invalid &&
              (signupForm.controls['newPassword']?.dirty ||
                signupForm.controls['newPassword']?.touched)
            "
            class="errorinput text-left"
          >
            <div *ngIf="signupForm.controls['newPassword']?.errors.required">
              *New Password is required.
            </div>
            <div *ngIf="signupForm.controls['newPassword']?.errors.minlength">
              *Minimum password length is 8.
            </div>
          </div>
        </div>
        <!-- <img src="../../../assets/images/eye-slash.svg" -->
        <div class="form-group mt-4">
          <label for="confirmPassword">Confirm Password</label>
          <div class="password-container">
            <input
              [type]="visiblePassword ? 'text' : 'password'"
              class="form-control form_Input mt-2"
              id="confirmPassword"
              formControlName="confirmPassword"
              placeholder="Enter confirm password"
            />
            <img
              src="{{
                visiblePassword
                  ? 'assets/images/eye.svg'
                  : 'assets/images/eye-slash.svg'
              }}"
              alt="Toggle password visibility"
              class="toggle-password"
              (click)="togglePasswordVisibility1()"
            />
          </div>
          <div
            *ngIf="
              signupForm.controls['confirmPassword'].invalid &&
              (signupForm.controls['confirmPassword']?.dirty ||
                signupForm.controls['confirmPassword']?.touched)
            "
            class="errorinput text-left"
          >
            <div *ngIf="signupForm.controls['confirmPassword'].errors.required">
              *Confirm Password is required.
            </div>
            <div
              *ngIf="signupForm.controls['confirmPassword'].errors.minlength"
            >
              *Minimum assword length is 8.
            </div>
          </div>
        </div>
        <div class="button_div mt-5">
          <button
            [disabled]="!signupForm.valid"
            type="submit"
            class="btn btn-primary btn-Login"
            (click)="ChangePassword()"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
